import api from './apiClient'

export default {
  /**
   * 📋 Get orders list (with filters & pagination)
   */
  async getOrders(params = {}) {
    const res = await api.get('orders', {
      params
    })
    return res.data
  },

  /**
   * 👤 Get single order
   */
  async getOrder(id) {
    const res = await api.get(`orders/${id}`)
    return res.data
  },

  /**
   * ✏️ Update order
   */
  async placeOrder(data) {
    try {
      const res = await api.post('orders', data)
      return {
        data: res.data,
        message: res.data.message || 'Order placed successfully'
      }
    } catch (error) {
      const err = error.response
  
      throw err
    }
  },


  /**
   * ✏️ Place order
   * */
  async placeOrderTrial(data) {
    try {
      const res = await api.post('orders/trial', data)
      return {
        data: res.data,
        message: res.data.message || 'Order placed successfully'
      }
    } catch (error) {
      const err = error.response
  
      throw err
    }
  },
  
  /**
   * Check order reference
   */
  async checkReference(reference) {
    const res = await api.get(`orders/check-reference-existing?reference=${reference}`)
    return res.data
  },

  /**
   * Print Invoice
   */
  async printInvoice(orderId) {
    try {
      const res = await api.get(`orders/${orderId}/print-invoice`)
      return res.data
    } catch (error) {
      const err = error.response
  
      throw err
    }
  },


  async submitPayment(orderId, data) {
    try {
      const res = await api.post(`/orders/${orderId}/pay`, data)
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.data.status,
        message: err?.data.message || 'Something went wrong',
        errors: err?.data.errors || {}
      }
    }
  },
}